"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uploadEvent = _interopRequireDefault(require("./upload-event"));
// import PropsMain from './props-main'
var _default = exports.default = [_uploadEvent.default];